import { Component, OnInit, inject } from '@angular/core';
import { ExternalLoginService } from '@clubhub/services';

@Component({
  selector: 'app-external-login',
  templateUrl: 'external-login.component.html',
  styleUrls: ['external-login.component.scss'],
})
export class ExternalLoginComponent implements OnInit {
  private readonly externalAuthService = inject(ExternalLoginService);

  public ngOnInit() {
    this.externalAuthService.loginExternalUser();
  }
}
